const ASK_FOR_CAMERA_PERMISSION = 'ask-for-camera-permission'
const CHANGE_SETTINGS = 'change-settings'

const askForCameraPermission = () => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(ASK_FOR_CAMERA_PERMISSION)
  }
}

const changeAppSettings = () => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(CHANGE_SETTINGS)
  }
}

const onPermissionResult = (permissionStatus) => {
  // update permission status
}

export { askForCameraPermission, changeAppSettings, onPermissionResult }
